<div class="row">
	<div class="col-12 text-center">

		<div *ngIf="error" class="alert alert-danger">{{ "register.attivazione_ko" | translate }}</div>

		<div *ngIf="error2" class="alert alert-warning">{{ "register.attivazione_ok_no_login" | translate }}</div>

	</div>
</div>